import { createClient } from '@supabase/supabase-js';

const supabaseUrl: any = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey: any = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

const assistantSupabaseUrl: any = process.env.REACT_APP_ASSISTANT_SUPABASE_URL;
const assistantSupabaseKey: any = process.env.REACT_APP_ASSISTANT_SUPABASE_KEY;

export const assistantSupabase = createClient(assistantSupabaseUrl, assistantSupabaseKey);